import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";
// import { parseText } from "./parseText";

const urlBase = `${process.env.API_URL}/playbook`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const getPlaybooks = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  const clientId = query.get("clientId");

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");
  query.delete("clientId");

  let res = await fetch(readUrl(`/${clientId}?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getPlaybookById = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const createPlaybook = async (data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  res = await parseJSON(res);
  return res.success;
};

export const updatePlaybook = async (id, data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  res = await parseJSON(res);
  return res.success;
};

export const deletePlaybook = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const KpisPlaybook = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams();
  query.append("startDate", params.startDate);
  query.append("endDate", params.endDate);

  let res = await fetch(readUrl(`/kpi?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const exportPlaybook = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};
